mutation TeardownSsoForInstance {
    teardownSsoForInstance {
        success
    }
}
